import FollowersList from './FollowersList';

export default FollowersList;
